/* Global SCSS Variables -------------------------------------------------------------------------- */

@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

:root {
  --pm-font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  --pm-blue: #2170f7;
  --pm-blue-strong: #2b67ff;
  --pm-blue-accent: #2170f7;
  --pm-new-blue: #2170f7;
  --pm-blue-light: #e8f4ff;
  --pm-blue-lighter: #3687ff;
  --pm-blue-lighter-background: #2b67ff30;
  --pm-red: #ff3665;
  --pm-red-lighter: #ff3071;
  --pm-red-lighter-background: #ff005129;
  --pm-red-hover: #ff3665cc;
  --pm-green: #24c266;
  --pm-purple: #b54fe4;
  --pm-green-lighter: #009144;
  --pm-green-lighter-background: #1fc16b30;
  --pm-green-600: #22ac5b;
  --pm-orange-lighter: #e37a00;
  --pm-orange-lighter-background: #ff890030;
  --pm-teal-lighter: #009bb2;
  --pm-teal-lighter-background: #1fabc130;
  --pm-purple: #b54fe4;
  --pm-pink: #ff61c1;
  --pm-yellow: #f5cd00;

  --pm-text-primary: var(--pm-grey1);
  --pm-text-secondary: var(--pm-grey4);
  --pm-text-tertiary: var(--pm-grey6);
  --pm-text-button: var(--pm-grey5);
  --pm-text-warning: #7b3306;
  --pm-html-background: #ecf0f3;
  --pm-background: var(--pm-grey13);
  --pm-background-primary: #ffffff;
  --pm-background-secondary: #f8f9fa;
  --pm-background-tertiary: #ecf0f3;
  --pm-surface: var(--pm-white);
  --pm-surface-hover: #0000000a;
  --pm-button-hover-light: rgba(32, 71, 130, 0.06);
  --pm-border: var(--pm-grey10);
  --pm-border-light: var(--pm-grey11);
  --pm-stroke-soft-200: #e1e4ea;
  --pm-box-shadow: #14141426;
  --pm-sidebar: var(--pm-grey13);
  --pm-text-filled-button: #ffffff;
  --pm-modalstep: var(--pm-grey5);
  --pm-multipay-row: var(--pm-white);
  --pm-pill: var(--pm-grey12);
  --pm-overlay: var(--pm-grey13);
  --pm-inbox-pill-active-bg: rgba(33, 112, 247, 0.15);
  --pm-inbox-list-hover: var(--pm-button-hover-light);
  --pm-inbox-glimmer-sheen-low: rgba(255, 255, 255, 0.02);
  --pm-inbox-glimmer-sheen-high: rgba(255, 255, 255, 0.08);
  --pm-modal-backdrop: rgba(12, 15, 25, 0.1);
  --pm-menu-icon: #a4aabb;
  --pm-display-value: var(--pm-black);
  --pm-checkmark-background: var(--pm-blue);
  --pm-image-overlay-button-background: #fff;
  --pm-image-overlay-button-label: #0c0f19;
  --pm-data-block-row-height: 2.8125rem;
  --pm-data-block-row-padding-block: 0.3125rem;
  --pm-data-block-label-line-height: 1rem;
  --pm-data-block-value-line-height: 1rem;
  --pm-data-block-label-margin-bottom: 0.125rem;

  --pm-black: #0c0f19;
  --pm-grey1: #1e232f;
  --pm-grey2: #313131;
  --pm-grey3: #3d3d3d;
  --pm-grey4: #4c5261;
  --pm-grey5: #5f6677;
  --pm-grey6: #6f778c;
  --pm-grey7-polars: #8e96aa;
  --pm-grey7: #969696;
  --pm-grey8: #a4aabb;
  --pm-grey9: #bcc1cd;
  --pm-grey10: #dee1e8;
  --pm-grey11: #e9ecf3;
  --pm-grey12: #f2f4f8;
  --pm-grey13: #f6f8fa;
  --pm-white: #ffffff;
  --pm-darksurface: rgba(255, 255, 255, 0.065);
}

.mdc-dialog__body.mdc-dialog__body--scrollable {
  overscroll-behavior: contain;
}

/* Dark mode colors */
/* Attribute selectors avoid CSS module scoping across import paths. */
:root[class~="theme-dark1"],
body[class~="template_doc"][class~="theme-dark1"] {
  --D1: #101012;
  --D2: #18181a;
  --D3: #1e1e22;
  --D4: #26262b;
  --D5: #2b2b31;
  --D6: #323239;
  --D7: #3f3f46;
  --D9: #5e5e68;
  --D10: #6f6f7b;
  --D11: #898994;
  --D12: #a4a4ad;
  --D13: #bfbfc4;
  --D14: #cfcfd3;
  --D16: #ededef;

  --pm-blue: var(--pm-blue-lighter);
  --pm-blue-strong: #3d8aff;
  --pm-blue-accent: #3d8aff;
  --pm-blue-light: var(--pm-blue-lighter-background);
  --pm-text-primary: var(--D16);
  --pm-text-secondary: #d9d9d9;
  --pm-text-tertiary: var(--D11);
  --pm-text-button: var(--D11);
  --pm-text-warning: #ffae51;
  --pm-html-background: var(--D1);
  --pm-background: var(--D2);
  --pm-background-primary: #232323;
  --pm-background-secondary: #313131;
  --pm-background-tertiary: #3d3d3d;
  --pm-surface: var(--D3);
  --pm-surface-hover: var(--D2);
  --pm-button-hover-light: var(--D4);
  --pm-border: var(--D7);
  --pm-border-light: var(--D6);
  --pm-stroke-soft-200: var(--pm-border-light);
  --pm-sidebar: var(--D2);
  --pm-modalstep: var(--D12);
  --pm-multipay-row: var(--D4);
  --pm-pill: var(--D5);
  --pm-overlay: var(--D3);
  --pm-inbox-pill-active-bg: rgba(61, 138, 255, 0.13);
  --pm-inbox-list-hover: rgba(185, 185, 225, 0.08);
  --pm-modal-backdrop: rgba(12, 15, 25, 0.1);
  --pm-display-value: var(--D13);
  --pm-checkmark-background: var(--pm-blue);

  /* Legacy color variables for compatibility - flipped for dark mode */
  --pm-black: var(--D16);
  --pm-white: var(--D3);
  --pm-grey1: #f8f9fa;
  --pm-grey2: #ecf0f3;
  --pm-grey3: #d9d9d9;
  --pm-grey4: #969696;
  --pm-grey5: #777777;
  --pm-grey6: var(--D11);
  --pm-grey7-polars: #8e96aa;
  --pm-grey7: #525152;
  --pm-grey8: #3d3d3d;
  --pm-grey10: var(--D7);
  --pm-grey11: var(--D4);
  --pm-grey12: var(--D3);
  --pm-grey13: #2c2c2f;
  --pm-darksurface: rgba(0, 0, 0, 0.65);
}
